import ShareVector from '../../media/ShareVector.svg'

export default function LinkExpired() {
  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <img style={styles.img} src={ShareVector} alt='' />
        <h2 style={styles.h2}>Link Expired</h2>
        <p style={styles.p}>This share link has expired.</p>
      </div>
    </div>
  );
}

const styles = {
  img:{
    width:310
  },
  h2:{
    fontWeight: 500,
    fontSize: 20,
    marginTop:10,
    marginBottom:5

  },
  p:{
    marginTop:0,
    color: "#C8CDD0",
    fontSize:16

  },
  wrapper: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#fff",
  },
  card: {
    textAlign: "center",
  },
};